module.exports = __webpack_public_path__ + "img/VetoSans-BoldItalic_1.f83ddd92.svg";